<template>
  <transition name="modal">
    <form @submit.prevent="submit">
      <modal :close="close">
        <h3 slot="header">Log in</h3>
        <div slot="body">
          <div class="modal-body">
            <p>{{ $t("login.slogan") }}</p>
            <alert v-for="(error, index) in errors" :key="index" :error="error"></alert>
            <div class="form-group">
              <input type="text" :placeholder="$t('login.username')" v-model="credentials.user.email" class="form-control" autofocus/>
            </div>
            <div class="form-group position-relative">
              <input :type="passowordType" :placeholder="$t('login.password')" v-model="credentials.user.password" class="form-control"/>
              <div class="visible_toggle">
                <button type="button" v-if="passowordType === 'password'" @click.prevent="passowordType = 'text'">
                  <img src="~assets/img/ico_cross_eye.svg" alt="">
                </button>
                <button type="button" v-else @click.prevent="passowordType = 'password'">
                  <img src="~assets/img/ico_eye.svg" alt="">
                </button>
              </div>
              <!-- <div class="checkbox">
                <label>
                  <input type="checkbox" value="">
                  <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                  {{ $t("login.remember") }}
                </label>
              </div> -->
              <br>
              <p><a href="#" @click.prevent='forgotPassword'>{{ $t("login.forgot") }}</a></p>
            </div>
            <button type="button" @click.prevent="fbLogin()" class="btn btn-primary" style="width:100%">Log in with Facebook</button>
          </div>
        </div>
        <div slot="footer" style="display: inline">
          <button type="submit" class="btn btn-primary">{{ $t("login.logInButtom") }}</button>
        </div>
      </modal>
    </form>
  </transition>
</template>

<script>
import auth from '@/api/v1/auth/authService';
import facebook from '@/api/facebook';

import Alert from '@/components/Alert';
import Modal from '@/components/Modal';

export default {
  props: ['close'],
  components: { Alert, Modal },
  data() {
    return {
      credentials: {
        user: {
          email: '',
          password: '',
        },
      },
      errors: [],
      passowordType: 'password',
    };
  },
  methods: {
    submit() {
      // Pass the component's this context
      auth.login(this, this.credentials);
    },
    forgotPassword() {
      this.close();
      this.$router.push({ name: 'forgot_password' });
    },
    fbLogin() {
      const vm = this;
      function succ(accessToken) {
        auth.fbLogin(vm, accessToken);
      }
      facebook.login(succ);
    },
  },
};
</script>



// WEBPACK FOOTER //
// LoginModal.vue?bdc41c7a